<template>
    <div>
        <div v-if="currentTheme === 'phoenix'">
            <PhoenixBoxAction
                @click="plaidChangeBank()"
                text="Click here to securely verify your bank account."
                label="Instant connection"
                appareance="instant-connection"
            />
            
            <div v-if="loan.banking_user_id == 0">
                <div class="divider-- flex justify-center items-center gap-5 mt-4 mb-0">
                    <div style="height: 1px; background-color: #d9dbde; width: 20px"></div>
                    <div class="text-black font-semibold">Or</div>
                    <div style="height: 1px; background-color: #d9dbde; width: 20px"></div>
                </div>
        
                <PhoenixBoxAction
                    @click="handleManual()"
                    text="Requires bank <br class='hidden md:block' /> statements."
                    label="Manual"
                    appareance="manual-connection"
                />
            </div>

        </div>
        <div v-else>
            <BoxAction
                @click="plaidChangeBank()"
                text="Click here to securely verify your bank account"
                label="Instant connection"
                badge="Fast way"
            />

            <div v-if="loan.banking_user_id == 0">
                <AppDivider apparance="or" />
    
                <BoxAction
                    data-testid="manual"
                    text="Requires bank statements"
                    label="Manual"
                    appareance="white"
                    @click="handleManual"
                />
            </div>
        </div>

        <AppBankManualModal :showModal="showManual" :loan="loan" :isChangingBankFlow="true" @close="handleCloseManual" @proceed="proceed" />
    </div>
</template>

<script>
import PhoenixBoxAction from "./../themes/phoenix/components/PhoenixBoxAction.vue";
import AppBankManualModal from "./AppBankManualModal.vue";
import BoxAction from "../themes/aurora/components/AuroraBoxAction.vue";
import AppDivider from "./AppDivider.vue";

export default {
    mixins: [
        require("../mixins/VerifyMethods").default,
    ],
    components: {
        PhoenixBoxAction, AppBankManualModal, BoxAction, AppDivider
    },
    props: {
        csrf: {},
        user: {},
        loan: {},
        mxWidgetUrl: {},
        plaidLinkToken: {}
        
    },

    data() {
        return {
            showManual: false,
            currentTheme: window.theme
        }
    },

    created() {        
    },

    mounted() {
    },

    methods: {
    }
}
</script>